import { render, staticRenderFns } from "./CombatPVP.vue?vue&type=template&id=1ad134d0&scoped=true&"
import script from "./CombatPVP.vue?vue&type=script&lang=js&"
export * from "./CombatPVP.vue?vue&type=script&lang=js&"
import style0 from "./CombatPVP.vue?vue&type=style&index=0&id=1ad134d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad134d0",
  null
  
)

export default component.exports